import axios from 'axios';

class Api{
  constructor(){
    this.http = axios.create({
      transformResponse: [function (data) {

        return data;
      }],
      responseType: 'json'
    });
  }

  post(url){
    return this.http.post(url);
  }

  get(url){
    return this.http.get(url);
  }
}

export default new Api();
